import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

// Helper function to format dates for API
const formatDate = (date: any) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toISOString().split("T")[0];
};

export const fetchDispatchIssueToLabourList = createAsyncThunk(
  "Dispatch/IssueToLabour/fetchDispatchIssueToLabourList",
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters,
    warehouse_id,
  }: {    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (filters?.length) {
      filters.forEach(({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null) return;

        // Handle date-range filters (object with from_date / to_date)
        if (typeof filterValue === "object" && filterValue !== null && !Array.isArray(filterValue)) {
          const { from_date, to_date } = filterValue;

          // Handle dispatch_date and created_at date filters
          if (
            from_date &&
            (filterField === "dispatch_date" || filterField === "created_at"  || filterField === "updated_at")
          ) {
            params.append(`${filterField}_from`, formatDate(from_date));
          }

          if (
            to_date &&
            (filterField === "dispatch_date" || filterField === "created_at"  || filterField === "updated_at")
          ) {
            params.append(`${filterField}_to`, formatDate(to_date));
          }

          return; // Stop processing here for date objects
        }

        // Handle simple filters (string, number, etc.)
        params.append(filterField, String(filterValue));
      });
    }
    params.append("warehouse_id", warehouse_id);
    const response = await Axios.get(`${api.Inventory.dispatch.issue_to_labour.listing}?${params.toString()}`); 
    
    // Return structured data matching reducer expectations
    return {
      data: response?.data?.data || [],
      rowCount: response?.data?.count || response?.data?.rowCount || 0,
    };
  }
);


export const exportDispatchIssueToLabourCSV = createAsyncThunk(
  "Dispatch/IssueToLabour/exportDispatchIssueToLabourCSV",
  async ({
    filters,
  }: {
        filters: any;
  }) => {
    const params = new URLSearchParams({ export: "csv", ...filters } as any);
    const response = await Axios.get(`${api.warehouse.dispatch.issue_to_labour.export_csv}?${params.toString()}`);
    return response.data;
  }
);


export const fetchDispatchIssueToLabourById = createAsyncThunk(
  "Dispatch/IssueToLabour/fetchDispatchIssueToLabourById",
  async ({
    id,
  }: {
    id: string;
  }) => {
    try {
      const response = await Axios.get(`${api.Inventory.dispatch.issue_to_labour.getByID}${id}`);
      return response?.data?.data || response?.data || {};
    } catch (error: any) {
      throw new Error(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch issue to labour details"
      );
    }
  }
);

